
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.9.0
 * Query Engine version: 81e4af48011447c3cc503a190e86995b66d2a28e
 */
Prisma.prismaVersion = {
  client: "6.9.0",
  engine: "81e4af48011447c3cc503a190e86995b66d2a28e"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailVerified: 'emailVerified',
  image: 'image',
  name: 'name',
  role: 'role',
  isTwoFactorEnabled: 'isTwoFactorEnabled'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  token: 'token',
  expires: 'expires',
  email: 'email',
  id: 'id'
};

exports.Prisma.PasswordResetTokenScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.TwoFactorTokenScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.TwoFactorConfirmationScalarFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.EmailScalarFieldEnum = {
  id: 'id',
  email: 'email',
  createdAt: 'createdAt'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  domain: 'domain',
  createdBy: 'createdBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  autoJoin: 'autoJoin',
  slug: 'slug',
  industry: 'industry'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  content: 'content',
  createdAt: 'createdAt',
  workspaceId: 'workspaceId'
};

exports.Prisma.ChannelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  archived: 'archived',
  endDate: 'endDate',
  startDate: 'startDate',
  eventStartDate: 'eventStartDate',
  eventEndDate: 'eventEndDate',
  timezone: 'timezone',
  domain: 'domain',
  playbookId: 'playbookId',
  lumaEventId: 'lumaEventId',
  collaborationType: 'collaborationType',
  rsvpTarget: 'rsvpTarget',
  isArchived: 'isArchived',
  archivedAt: 'archivedAt'
};

exports.Prisma.PartnerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  domain: 'domain',
  url: 'url',
  primary: 'primary',
  description: 'description',
  channelId: 'channelId',
  isArchived: 'isArchived',
  archivedAt: 'archivedAt'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  workspaceId: 'workspaceId',
  channelId: 'channelId',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.PlaybookScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HubSpotConfigScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  portalId: 'portalId',
  environment: 'environment',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  expiresAt: 'expiresAt',
  scope: 'scope',
  hubspotId: 'hubspotId'
};

exports.Prisma.HubSpotFormScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  formId: 'formId',
  formName: 'formName',
  portalId: 'portalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  settings: 'settings',
  workspaceConfigId: 'workspaceConfigId'
};

exports.Prisma.LumaEventScalarFieldEnum = {
  id: 'id',
  lumaEventId: 'lumaEventId',
  name: 'name',
  channelId: 'channelId',
  calendarApiId: 'calendarApiId',
  capacity: 'capacity',
  coverImageUrl: 'coverImageUrl',
  createdAt: 'createdAt',
  description: 'description',
  descriptionMd: 'descriptionMd',
  durationInterval: 'durationInterval',
  endDate: 'endDate',
  geoAddressJson: 'geoAddressJson',
  geoLatitude: 'geoLatitude',
  geoLongitude: 'geoLongitude',
  hosts: 'hosts',
  location: 'location',
  meetingUrl: 'meetingUrl',
  registrationUrl: 'registrationUrl',
  startDate: 'startDate',
  timezone: 'timezone',
  updatedAt: 'updatedAt',
  userApiId: 'userApiId',
  visibility: 'visibility',
  zoomMeetingUrl: 'zoomMeetingUrl'
};

exports.Prisma.UtmLinkScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  eventId: 'eventId',
  eventType: 'eventType',
  sourceName: 'sourceName',
  targetUrl: 'targetUrl',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmContent: 'utmContent',
  utmTerm: 'utmTerm',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChannelUsersScalarFieldEnum = {
  A: 'A',
  B: 'B'
};

exports.Prisma.WorkspaceMembersScalarFieldEnum = {
  A: 'A',
  B: 'B'
};

exports.Prisma.EventSignUpScalarFieldEnum = {
  id: 'id',
  source: 'source',
  guestId: 'guestId',
  email: 'email',
  eventId: 'eventId',
  status: 'status',
  channelId: 'channelId',
  firstName: 'firstName',
  lastName: 'lastName',
  title: 'title',
  company: 'company',
  connectionType: 'connectionType',
  leadSource: 'leadSource',
  partnerIntel: 'partnerIntel',
  name: 'name',
  phoneNumber: 'phoneNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invitedAt: 'invitedAt',
  joinedAt: 'joinedAt',
  checkedInAt: 'checkedInAt',
  hubspotContactId: 'hubspotContactId'
};

exports.Prisma.ChannelABMScalarFieldEnum = {
  id: 'id',
  companyName: 'companyName',
  vertical: 'vertical',
  partnerData: 'partnerData',
  priority: 'priority',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  channelId: 'channelId',
  partnerId: 'partnerId'
};

exports.Prisma.ChannelABMRelationshipScalarFieldEnum = {
  id: 'id',
  name: 'name',
  relationship: 'relationship',
  channelABMId: 'channelABMId'
};

exports.Prisma.TestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.UserRole = exports.$Enums.UserRole = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  MEMBER: 'MEMBER',
  GUEST: 'GUEST'
};

exports.EventSignUpStatus = exports.$Enums.EventSignUpStatus = {
  APPROVED: 'APPROVED',
  SESSION: 'SESSION',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  INVITED: 'INVITED',
  DECLINED: 'DECLINED',
  WAITLIST: 'WAITLIST'
};

exports.Prisma.ModelName = {
  User: 'User',
  Account: 'Account',
  VerificationToken: 'VerificationToken',
  PasswordResetToken: 'PasswordResetToken',
  TwoFactorToken: 'TwoFactorToken',
  TwoFactorConfirmation: 'TwoFactorConfirmation',
  Email: 'Email',
  Workspace: 'Workspace',
  Message: 'Message',
  Channel: 'Channel',
  Partner: 'Partner',
  Invitation: 'Invitation',
  Playbook: 'Playbook',
  HubSpotConfig: 'HubSpotConfig',
  HubSpotForm: 'HubSpotForm',
  LumaEvent: 'LumaEvent',
  UtmLink: 'UtmLink',
  ChannelUsers: 'ChannelUsers',
  WorkspaceMembers: 'WorkspaceMembers',
  EventSignUp: 'EventSignUp',
  ChannelABM: 'ChannelABM',
  ChannelABMRelationship: 'ChannelABMRelationship',
  Test: 'Test'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
